//NOTE: 'production' as a value is deprecated but still used by PP and maybe PPP
export const isProd = process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'production';
